<app-course-header [color]='logData?.courses'></app-course-header>


<div class="ilalert">
    <div class="alert alert-server text-center" role="alert">
        <button type="button" class="close" data-dismiss="alert">×</button>
        <p class="mb-0">Get upto 100% Scholarship and prizes worth 10cr* | <strong>9 Days left!</strong>
            <a href="#" class="alertregister">&nbsp;&nbsp;&nbsp;&nbsp;Register Now! &nbsp;<span><img
                        src="assets/img/arrowright.png" alt=""></span></a>
        </p>
    </div>
</div>


<div class="neetJeepage" [ngClass]='{"JEEcolor": logData?.courses == "jee", "NEETcolor": logData?.courses == "neet"}'>
<router-outlet></router-outlet>
</div>
<app-course-footer></app-course-footer>
